module.exports = __webpack_public_path__ + "img/1sb-five-stars-boutique-star-selected.6e2ed6b.svg";